import { useState, useEffect } from "react";
import { saveStoreDetails, getOfficeOptions } from "../Api/StoreMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const StoreMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [officeOptions, setOfficeOptions] = useState([]);
  const [storeData, setStoreData] = useState({
    code: "",
    name: "",
    officeCode: ""
  });

  // Get user details from localStorage
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  useEffect(() => {
    const fetchOfficeOptions = async () => {
      try {
        const options = await getOfficeOptions();
        setOfficeOptions(options);
      } catch (error) {
        toast.error("🦄 Failed to load office options");
      }
    };
    fetchOfficeOptions();
  }, []);

  const handleChange = (e) => {
    setStoreData({ ...storeData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveStoreDetails({
        code: storeData.code,
        name: storeData.name,
        officeCode: storeData.officeCode
      }, userId);
      toast.success("🦄 Store Added Successfully");
      setStoreData({
        code: "",
        name: "",
        officeCode: ""
      });
      navigate("/viewStoreMaster");
    } catch (error) {
      toast.error("🦄 Some Error Happened");
      console.error("Error saving store:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Store Master</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Store Code <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="text" 
                      name="code" 
                      value={storeData.code} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Store Name <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="text" 
                      name="name" 
                      value={storeData.name} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Office Code <span className="text-red">**</span></Form.Label>
                    <Form.Select 
                      name="officeCode" 
                      value={storeData.officeCode} 
                      onChange={handleChange} 
                      required
                    >
                      <option value="">Select Office</option>
                      {officeOptions.map((office, index) => (
                        <option key={index} value={office.officeCode}>
                          {office.officeCode} - {office.officeName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Store
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default StoreMaster;